import Axios, { AxiosError, AxiosResponse } from "axios";
import { SERVICE_API_BASE_URL } from "@configs";

export const AmityServiceAxios = Axios.create({
  baseURL: SERVICE_API_BASE_URL,
});

AmityServiceAxios.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data;
  },
  (error: AxiosError) => {
    return Promise.reject(error.response?.data);
  }
);
